import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./commanComponents.css";
import newLogo from "../assets/images/newLogo.png";
import { navData } from "../constants/utilities/NavTabsData";
import { getUserDetails } from "../constants/helpers/getUserDetails";
import svgData from "../constants/utilities/svgData";
import PopupModel from "./PopupModel";

export default function Sidebar({ active }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogout, setShowLogout] = useState(false);
  const tokenName = process.env.REACT_APP_PUBLIC_TOKENNAME;
  const userDetails = process.env.REACT_APP_PUBLIC_USERDETAILS;
  const itemRefs = useRef([]);
  const [indicatorStyle, setIndicatorStyle] = useState({ transform: "translateY(0px)", height: "56px", opacity: 0 });

  const designation = getUserDetails()?.designation;
  const userRoles = Array.isArray(designation) ? designation.map((d) => d.toLowerCase()) : typeof designation === "string" ? [designation.toLowerCase()] : [];
  const isAdmin = userRoles.includes("admin") || userRoles.includes("superadmin");

  const allowedNavData = navData?.filter((ele) => {
    if (isAdmin) return true;
    if (!ele?.allowedRoles) return false;
    return userRoles.some((r) => ele.allowedRoles.includes(r));
  });
  const activeIndex = navData?.findIndex((ele) => active === ele?.active || location.pathname.includes(ele?.url) || (ele?.url?.includes("/settings/") && location.pathname.includes("/settings/")));

  useEffect(() => {
    // We add a small timeout to ensure the DOM is fully rendered (especially if fonts or texts wrap)
    const timer = setTimeout(() => {
      if (activeIndex >= 0 && itemRefs.current[activeIndex]) {
        const activeEl = itemRefs.current[activeIndex];
        setIndicatorStyle({
          transform: `translateY(${activeEl.offsetTop}px)`,
          height: `${activeEl.offsetHeight}px`,
          opacity: 1,
        });
      } else {
        setIndicatorStyle((prev) => ({
          ...prev,
          opacity: 0,
        }));
      }
    }, 50);
    return () => clearTimeout(timer);
  }, [activeIndex, location.pathname, allowedNavData]);

  return (
    <div className="sidebar">
      <div className="sidebarLogoContainer" onClick={() => navigate("/panel/dashboard")}>
        <div className="sidebarLogoBg">
          <img src={newLogo} alt="MOIL Logo" />
        </div>
        <h1>MOIL LIMITED</h1>
        <p>( A Government of India Enterprise )</p>
      </div>

      <div className="sidebarNav">
        <div className="sidebarActiveIndicator" style={indicatorStyle} />
        {navData?.map((ele, idx) => {
          const isActive = active === ele?.active || location.pathname.includes(ele?.url) || (ele?.url?.includes("/settings/") && location.pathname.includes("/settings/"));
          return (
            <div key={ele?.active} ref={(el) => (itemRefs.current[idx] = el)} className={`sidebarNavItem ${isActive ? "active" : ""}`} onClick={() => navigate(ele?.url)}>
              <span className="navIcon">{ele?.tabIcon}</span>
              <span className="navText">{ele?.tabName}</span>
            </div>
          );
        })}
      </div>

      <div className="sidebarFooter">
        <div className="sidebarDivider"></div>
        <button className="logoutBtn" onClick={() => setShowLogout(true)}>
          <span className="logoutIcon">{svgData?.logOutIcon}</span>
          Logout
        </button>
      </div>

      <PopupModel setShow={setShowLogout} show={showLogout} dialogClassName="logoutPopupDialog">
        <h3 className="logoutPopupTitle">Log Out ?</h3>
        <p className="logoutPopupText">Are you sure, You want to Logout ?</p>
        <div className="logoutPopupButtons">
          <button className="logoutPopupBtnCancel" onClick={() => setShowLogout(false)}>
            Cancel
          </button>
          <button
            className="logoutPopupBtnConfirm"
            onClick={() => {
              sessionStorage.removeItem(tokenName);
              sessionStorage.removeItem(userDetails);
              navigate("/login");
            }}
          >
            Logout
          </button>
        </div>
      </PopupModel>
    </div>
  );
}
